import { ChatsCircle } from '@phosphor-icons/react';

export default ChatsCircle;
